import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setEtapeActive } from 'store/etapes/etapesActions';
import { reinitialiseAPI, getAPI } from 'store/apiReducer';
import { IndicateurEtapes, Bouton, Row, Col } from '@design-system-etat/dsfr-react';
import usagerClientReducer from 'store/usagerReducer';
import { TITRES } from 'constants/titreDetention.constants';
import useToaster from 'hooks/useToaster';
import {
    FEATURE_APPEL_API_FFTIR,
    isFeatureActive,
} from 'components/FeatureFlipping/featureFlipping.func';
import {
    API_FORM_TITRE_DETENTION_URL,
    CONTEXT_FORM_TITRE_DETENTION,
} from 'constants/apiUrls.constants';
import { useHistory } from 'react-router';
import CreerTitreDetentionEtape1 from './CreerTitreDetentionEtape1';
import CreerTitreDetentionEtape2 from './CreerTitreDetentionEtape2';

const CreerTitreDetention = () => {
    const history = useHistory();
    const { type } = useParams();
    const { etapeActive } = useSelector((state) => state.etapes.etapes); // TODO supprimer le dernier etape
    const dispatch = useDispatch();
    const etapes = [
        { key: 1, titre: 'Identité du demandeur' },
        { key: 2, titre: "Demande d'autorisation" },
    ];

    // initilaiser l'étape à la creation de composant
    useEffect(() => {
        dispatch(setEtapeActive(1));
    }, []);

    // Charger le formulaire et verfier les accées
    const {
        data: form,
        message: messageForm,
        isLoading,
    } = useSelector((state) => state.titreDetention.form);

    const { triggerToaster, closeToaster } = useToaster();
    const { data: featureFlipping } = useSelector((state) => state.featureFlipping);

    // Charger le formulaire dynamic depuis API
    useEffect(() => {
        dispatch(
            getAPI(
                usagerClientReducer,
                API_FORM_TITRE_DETENTION_URL.replace(':type', type),
                CONTEXT_FORM_TITRE_DETENTION,
            ),
        );
        return () => {
            dispatch(reinitialiseAPI(CONTEXT_FORM_TITRE_DETENTION));
        };
    }, [type]);

    useEffect(() => {
        // Après le dispatch qui interroge l'API si le toaster n'a pas été lancé on le trigger
        if (isFeatureActive(featureFlipping, FEATURE_APPEL_API_FFTIR)) {
            if (isLoading) {
                triggerToaster();
            } else {
                closeToaster();
            }
        }
    }, [isLoading, featureFlipping]);

    return (
        <>
            <h1>{TITRES[type]}</h1>
            {form && !form.erreur ? (
                <>
                    <IndicateurEtapes
                        etapeEnCours={etapeActive}
                        nombreEtapes={2}
                        titreEtapeEnCours={etapes.find((etape) => etape.key === etapeActive).titre}
                        titreProchaineEtape={
                            etapeActive === 1 ? etapes.find((etape) => etape.key === 2).titre : null
                        }
                    />
                    <div className="segment transfertArmes">
                        {!messageForm && etapeActive === 1 && (
                            <CreerTitreDetentionEtape1 type={type} />
                        )}
                        {!messageForm && etapeActive === 2 && (
                            <CreerTitreDetentionEtape2 type={type} defaultValues={form} />
                        )}
                    </div>
                </>
            ) : (
                <Row goutierre className="margin-top-md">
                    <Col lg={6}>
                        <Bouton
                            name="etapePrecedente"
                            label="Retour"
                            niveau="secondaire"
                            onClick={history.goBack}
                        />
                    </Col>
                </Row>
            )}
        </>
    );
};

export default CreerTitreDetention;
